
$(".humMenu").click(function () {
	$(this).toggleClass('active');
	$(".moveNav").toggleClass('is-open');
});

$(".moveNav__close").click(function () {
	$(".humMenu").removeClass('active');
	$(".moveNav").removeClass('is-open');
});

// $(function () {
// 	$('a[href^="#"]').click(function () {
// 		let speed = 500;
// 		let href = $(this).attr("href");
// 		let target = $(href == "#" || href == "" ? 'html' : href);
// 		let position = target.offset().top;
// 		$("html, body").animate({ scrollTop: position }, speed, "swing");
// 		return false;
// 	});
// });


$(document).ready(function () {
	var urlHash = location.hash;
	if (urlHash) {
		$('body,html').stop().scrollTop(0);
		setTimeout(function () {
			scrollToAnker(urlHash);
		}, 100);
	}


	$('a[href^="#"]').click(function () {
		var href = $(this).attr("href");
		var hash = href == "#" || href == "" ? 'html' : href;
		scrollToAnker(hash);
		return false;
	});

	// 関数：スムーススクロール
	// 指定したアンカー(#ID)へアニメーションでスクロール
	function scrollToAnker(hash) {
		var target = $(hash);
		var position = target.offset().top - 80;
		$('body,html').stop().animate({ scrollTop: position }, 500);
	}
})

$(function () {
	$(window).scroll(function () {
		var scroll = $(this).scrollTop();

		if (scroll > 200) {
			$("#toTopBtn").fadeIn('1600');
			var scrollHeight = $(document).height();
			var scrollPosition = $(window).height() + $(window).scrollTop();
			var footHeight = $(".toTopWrap").innerHeight();
			if (scrollHeight - scrollPosition <= footHeight) {
				$("body").css("position", "relative");
				$("#toTopBtn").css({
					"position": "absolute",
					"display": "flex",
					"bottom": footHeight + 30
				});
			} else {
				$("#toTopBtn").css({
					"position": "fixed",
					"bottom": "20px"
				});
			}
		} else {
			$("#toTopBtn").fadeOut('800');
		}
	});
});


$(function () {
	$(window).scroll(function () {
		$('.trans,.trans2,.trans3').each(function () {
			const targetElement = $(this).offset().top;
			const scroll = $(window).scrollTop();
			const windowHeight = $(window).height();
			if (scroll > targetElement - windowHeight) {
				$(this).addClass('is-show');
			}
		});
	});
});

// var scrollElm = (function () {
// 	if ('scrollingElement' in document) { return document.scrollingElement; }
// 	if (navigator.userAgent.indexOf('WebKit') != -1) { return document.body; }
// 	return document.documentElement;
// })();

// var menuBtn = document.getElementById('menuBtn');
// var menu = document.getElementById('menu');

// (function () {
// 	var duration = 300;
// 	var ignore = '.noscroll';
// 	var easing = function (t, b, c, d) { return c * (0.5 - Math.cos(t / d * Math.PI) / 2) + b; }; //jswing
// 	var smoothScrollElm = document.querySelectorAll('a[href^="#"]:not(' + ignore + ')');
// 	Array.prototype.forEach.call(smoothScrollElm, function (elm) {
// 		elm.addEventListener('click', function (e) {
// 			e.preventDefault();
// 			var href = (elm.getAttribute('href') === '#') ? 'html' : elm.getAttribute('href');
// 			var targetElm = document.querySelector(href);
// 			if (!targetElm) return;
// 			var startTime = Date.now();
// 			var scrollFrom = scrollElm.scrollTop;
// 			(function loop() {
// 				var targetPos = targetElm.getBoundingClientRect().top + scrollElm.scrollTop - scrollFrom;
// 				var currentTime = Date.now() - startTime;
// 				if (currentTime < duration) {
// 					scrollTo(0, easing(currentTime, scrollFrom, targetPos, duration));
// 					window.requestAnimationFrame(loop);
// 				} else {
// 					scrollTo(0, targetPos + scrollFrom);
// 				}
// 			})();
// 			menuClose();
// 		})
// 	});
// })();

// function menuToggle() {
// 	if (menu.classList.contains('show')) {
// 		menuClose();
// 	} else {
// 		menu.classList.add('show');
// 		menuBtn.classList.add('on');
// 	}
// }
// function menuClose() {
// 	menu.classList.remove('show');
// 	menuBtn.classList.remove('on');
// }
// menuBtn.addEventListener('click', menuToggle, false);

// var animationElm = document.querySelectorAll('.anm');
// var sa = [];
// var saMargin = window.innerHeight * 0.2;
// for (var i = 0; animationElm.length > i; i++) {
// 	sa[i] = saFunc(animationElm[i]);
// }

// function saFunc(elm) {
// 	var status = true;
// 	var pos = elm.getBoundingClientRect().top;
// 	var delay = elm.getAttribute('data-delay');
// 	var trigger = elm.getAttribute('data-trigger');
// 	var trigElm = (trigger) ? document.querySelector(trigger) : elm;
// 	var showItem = function () {
// 		elm.classList.add('show');
// 		status = false;
// 	}
// 	return function (scroll) {
// 		if (!status) return;
// 		pos = trigElm.getBoundingClientRect().top;
// 		if (pos < window.innerHeight - saMargin || elm.classList.contains('animation_afterLoad')) {
// 			if (delay) {
// 				setTimeout(function () {
// 					showItem();
// 				}, delay);
// 				return;
// 			}
// 			showItem();
// 		}
// 	}
// }

// var saListener = function () {
// 	var scroll = scrollElm.scrollTop;
// 	for (var i = 0; sa.length > i; i++) {
// 		sa[i](scroll);
// 	}
// }

// window.addEventListener('load', saListener);
// window.addEventListener('scroll', saListener);

